module.exports = __webpack_public_path__ + "img/share-tip.1df21038.png";